"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createNewMoistureLoadRevisionMutation = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.createNewMoistureLoadRevisionMutation = (0, graphql_tag_1.default) `
  mutation CreateNewMoistureLoadRevision(
    $moistureLoadFileId: ID!
    $name: String!
  ) {
    createNewMoistureLoadRevision(
      moistureLoadFileId: $moistureLoadFileId
      name: $name
    ) {
      id
      revisionNo
      moistureLoadNo
    }
  }
`;
//# sourceMappingURL=create-new-moisture-load-revision.js.map